import { Toast } from 'primereact/toast'
import React, { useEffect, useRef, useState } from 'react'
import Layout from '../common/Layout'
import { Link, useNavigate, useParams } from 'react-router-dom'
import ApiHelper from '../../helperFunction/ApiHelper'
import API_ENDPOINTS from '../../helperFunction/Constant'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from "yup";

const AddAdminUser = () => {

    const { id } = useParams()
    const isEdit = id ? true : false

    const toast = useRef(null)
    const navigate = useNavigate()
    const [showPassword, setShowPassword] = useState(false);

    const schema = yup.object({
        name: yup.string().required("Name is required"),
        email: isEdit ? yup.string().optional() : yup.string().required("Email is required"),
        password: isEdit ? yup.string().optional() : yup.string().required("Password is Required"),
        isActive: yup.boolean(),
    });

    const { register, handleSubmit, reset, formState: { errors }, } = useForm({ resolver: yupResolver(schema), });

    const resetValue = () => {
        reset({
            name: '',
            email: null,
            password: null,
            isActive: '',
        })
    }

    const resetValueEdit = () => {
        reset({
            name: '',
            isActive: '',
        })
    }

    useEffect(() => {
        isEdit && getAdminUser()
    }, [])

    const getAdminUser = () => {
        ApiHelper.get(`${API_ENDPOINTS.ADMIN_USERS}/${id}`).then((res) => {
            if (res.status === 200) {
                reset({
                    name: res.data.data.name,
                    email: res.data.data.email,
                    userType: res.data.data.userType,
                    isActive: res.data.data.isActive,
                })
            }
        }).catch((error) => {
            console.log("Error: ", error);
        })
    }


    const onSubmit = (data) => {
        if (isEdit) {
            update(data)
        } else {
            add(data)
        }
    };

    const add = (data) => {
        data.userType = 'superAdmin'
        ApiHelper.post(`${API_ENDPOINTS.ADMIN_USERS}/`, data).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
                setTimeout(() => {
                    navigate('/admin-users')
                }, 1500)
            }
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, life: 3000 })
        })
    };

    const update = (data) => {
        ApiHelper.put(`${API_ENDPOINTS.ADMIN_USERS}/${id}`, data).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
                setTimeout(() => {
                    navigate('/admin-users')
                }, 1500)
            }
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, life: 3000 })
        })
    };

    return (
        <>
            <Toast ref={toast} />
            <Layout>
                <div class="content-wrapper">
                    <div class="container-xxl flex-grow-1 container-p-y">
                        <div class="d-flex justify-content-between align-items-center py-3">
                            <h4 class="fw-bold py-3 mb-2">
                                <span class="d-flex text-muted fw-light"> 
                                    <p class="breadcrumb-item pageHeader active me-2 mb-0" aria-current="page" onClick={() => navigate('/admin-users')}> Admin Users </p> / <b className='mx-2'> {isEdit ? 'Edit' : "Add"} </b>
                                </span>
                            </h4>
                            <Link to="/admin-users" class="btn btn-secondary">⬅ Go Back</Link>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card mb-4">
                                    <div class="card-body">
                                        <form id="adminUserForm" onSubmit={handleSubmit(onSubmit)}>
                                            <div class="row mb-3">
                                                <div class="col-md-3">
                                                    <label class="form-label">Name</label>
                                                    <input type="text" name="name" class="form-control" {...register("name")} />
                                                    <small className="text-danger">{errors.name?.message}</small>
                                                </div>

                                                <div class="col-md-3">
                                                    <label class="form-label">Email</label>
                                                    <input type="text" name="email" disabled={!!isEdit} class="form-control" {...register("email")} />
                                                    <small className="text-danger"> {errors.email?.message} </small>
                                                </div>
                                                {!isEdit && (
                                                    <div className="col-md-3">
                                                        <label htmlFor="password" className="form-label"> Password </label>
                                                        <div className="input-group">
                                                            <input type={showPassword ? "text" : "password"} className="form-control" id="password" placeholder="********" {...register("password")} />
                                                            <button type="button" className="btn btn-outline-secondary" onClick={() => setShowPassword(!showPassword)}>
                                                                <i className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}></i>
                                                            </button>
                                                        </div>
                                                        <small className="text-danger"> {errors.password?.message} </small>
                                                    </div>
                                                )}

                                                <div class="col-md-3">
                                                    <label class="form-label">Status</label>
                                                    <div class="form-check form-switch mb-2">
                                                        <input class="form-check-input mt-2" name="isActive" type="checkbox" id="flexSwitchCheckDefault" {...register("isActive")} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mt-4">
                                                <button type="submit" class="btn btn-primary me-3">Save</button>
                                                <button type="button" onClick={() => isEdit ? resetValueEdit() : resetValue()} class="btn btn-secondary reset-btn">Reset</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}

export default AddAdminUser
